"use client";

import React, { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import styles from "./styles.module.scss";
import Button from "../Button";

const DisableDraftButton = () => {
  const [hidden, setHidden] = useState(true);
  const [isLeaving, setIsLeaving] = useState(false);
  const pathname = usePathname();
  useEffect(() => {
    if (!pathname?.startsWith("/studio") && window === parent) {
      setHidden(false);
    }
  }, [pathname]);
  const onClick = async () => {
    if (isLeaving) {
      return;
    }
    setIsLeaving(true);
    try {
      const response = await fetch("/api/disable-draft/", {
        cache: "no-store",
        credentials: "same-origin",
        method: "GET",
      });

      if (response.ok) {
        // Left spinning: the page is reloading.
        window.location.reload();
        return;
      }
      console.error("Failed to disable draft mode:", response.status);
    } catch (error) {
      console.error("Error disabling draft mode:", error);
    }
    setIsLeaving(false);
  };
  if (hidden) {
    return null;
  }
  return (
    <div className={styles.container}>
      <Button
        onClick={onClick}
        variant="rounded"
        size="md"
        theme="yellow"
        loading={isLeaving}
        aria-disabled={isLeaving || undefined}
      >
        Disable preview mode
      </Button>
    </div>
  );
};

export default DisableDraftButton;
